import axios from "axios";
import { ApiUrl } from "../configs/ApiUrl";

export function getAlldealers(email: string,accesstype:String) {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: ApiUrl + "?route=admin&action=getAllDealers&email=" + email+"&accesstype="+accesstype,
    headers: {},
  };
  return axios(config);
}
